export const initYourHouse = () => {
	const yourHouses = document.querySelectorAll( 'section.your-house figure.desktop svg' );

	if ( !yourHouses.length )
	{
		return;
	}

	Array.from( yourHouses ).forEach( ( it ) => {
		const section = it.closest( 'div.image' );

		if ( !section )
		{
			return;
		}

		const tooltip = section.querySelector( 'div.tooltip' ) as HTMLElement;

		if ( !tooltip )
		{
			return;
		}
		
		it.addEventListener( 'click', ( evt ) => {
			
			
			const target = evt.target as HTMLElement;
			const circle = target.closest( 'g[id*="Tooltip_"]' ) as HTMLElement;

			if ( !circle )
			{
				return;
			}

			if ( tooltip.classList.contains( 'show' ) && circle.dataset.text === tooltip.innerHTML )
			{
				tooltip.classList.remove( 'show' );

				return;
			}

			const sectionRect = section.getBoundingClientRect();
			const circleRect = circle.getBoundingClientRect();
			const top = circleRect.top - sectionRect.top;
			const left = circleRect.left + circleRect.width / 2 - sectionRect.left;

			tooltip.style.top = top + 'px';
			tooltip.style.left = left + 'px';
			tooltip.innerHTML = circle.dataset.text || '';
			tooltip.classList.add( 'show' );
		} );
	} );
};



// WEBPACK FOOTER //
// ./app/Routes/Index/YourHouse/index.ts